/**
 * Faz 9 vitrin metinleri (öneriler, yeniden alım zamanı, yapay zekâ görsel notu). Vitrin girişi
 * (`@zt/i18n/storefront`) yalnızca `storefront.*` gördüğü için `storefront.de.ts` → `storefrontDe.ai` altına bağlanır.
 */
export const storefrontAiDe = {
  alsoBought: 'Kunden, die dies kauften, kauften auch',
  cartRecommendations: 'Passend zu Ihrem Warenkorb',
  replenishmentTitle: 'Zeit zum Nachbestellen',
  replenishmentLead:
    'Geschätzt anhand Ihrer bisherigen Bestellungen; wenn Sie möchten, können Sie die Produkte schon jetzt in den Warenkorb legen.',
  replenishmentDue: 'Voraussichtliche Nachbestellung: {{date}}',
  aiImage: 'KI-generiertes Bild',
  replenishmentOverdue: 'Voraussichtliches Nachbestelldatum überschritten ({{date}})',
  replenishmentBasis: {
    own: 'Sie kaufen es etwa alle {{days}} Tage',
    typical: 'dieses Produkt wird meist alle {{days}} Tage gekauft',
  },
};
